import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ className = "" }) => {
  return (
    <footer className={`text-center py-4 ${className}`}>
      <div className="flex items-center justify-center gap-3 text-[11px] text-vd-pizarra">
        <Link to="/terms" className="hover:text-vd-tinta underline underline-offset-2 transition-colors">
          Términos y Condiciones
        </Link>
        <span className="text-vd-linea">·</span>
        <Link to="/privacy" className="hover:text-vd-tinta underline underline-offset-2 transition-colors">
          Aviso de Privacidad
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
